<div *ngIf="password$ | async as password; else noPassword" class="password-bar">
  <div *ngFor="let _ of points; let index=index" class="point"
       [style.background-color]="getColorFor(index, password)">
  </div>
</div>
<ng-template #noPassword>
  <div class="password-bar">
    <div *ngFor="let _ of points; let index=index" class="point"
         [style.background-color]="getColorFor(index, '')">
    </div>
  </div>
</ng-template>
<cp-validation-error class="password-strength-error"
                     [errors]="'passwordStrength'" [validate]="validate && !isStrongPassword" [collapseMargin]="false">
</cp-validation-error>
